//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../no/SelectBody.js";
import "../no/SelectNXObjectList.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BasePlane",1,"Plane",0],[0,"BeltThickness",1,0],[1,"BoundaryCurves",0,"Section",0],[0,"CAMRelief",1,0],[0,"CamDirection",1,"Direction",0],[0,"MachineAllowance",1,0],[1,"Product",0,"SelectBody",0],[1,"Profiles",0,"SelectNXObjectList",0],[0,"ProfilesDirection",1,0],[0,"UseApproxSheetBody",1,0]],[[["seedPoint","seedTangent"],"SeedPointInfo",{},2,0]],[]];
SPLM.Tooling.DieDesignTrimPostBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieDesignTrimPostBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;